import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Card, Input, DatePicker } from "@velocity-ehs/component-library";
import { useEffect } from "react";
import FormSkeleton from "../../../sharedComponents/FormSkeleton";
import { UserForm } from "../../UserManagement/User";

type EmploymentDetailsProps = {
  formMethods: UseFormReturn<UserForm, unknown>;
  isLoading: boolean;
  isReadOnly: boolean;
};

const EmploymentDetails = ({
  formMethods,
  isLoading,
  isReadOnly,
}: EmploymentDetailsProps): React.ReactElement => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    watch,
    clearErrors,
  } = formMethods;

  const currentPositionValue = watch("currentPosition");

  useEffect(() => {
    clearErrors("currentPositionStartDate");
  }, [currentPositionValue, clearErrors]);

  return (
    <Card
      title={t("employment_details_card_title")}
      style={{ paddingBottom: "2px" }}
    >
      {isLoading ? (
        <FormSkeleton rows={5} />
      ) : (
        <>
          <Input
            readOnly={isReadOnly}
            control={control}
            name="currentPosition"
            label={t("person_Current_Position")}
            rules={{
              maxLength: {
                value: 255,
                message: t("max_length_255_char_form_validation"),
              },
            }}
            errorMessage={errors ? errors.currentPosition?.message : undefined}
          />
          <DatePicker
            readOnly={isReadOnly}
            control={control}
            name="currentPositionStartDate"
            label={t("person_Current_Position_Start_Date")}
            errorMessage={
              errors && currentPositionValue
                ? errors.currentPositionStartDate?.message
                : undefined
            }
            rules={{
              required: currentPositionValue
                ? t("person_Form_Current_Position_Start_Date_Required")
                : undefined,
            }}
          />
          <Input
            type="number"
            readOnly={isReadOnly}
            control={control}
            name="yearsInJob"
            label={t("employment_details_card_years_in_current_position_label")}
          />
        </>
      )}
    </Card>
  );
};

export { EmploymentDetails };
